<!--
 * @Author: 🐝
 * @Date: 2023-12-07 14:43:34
 * @LastEditors: Ant🐜
 * @LastEditTime: 2023-12-16 16:07:57
 * @Description: 邀请二维码
-->
<template>
  <div v-if="bg" class="container">
    <div class="wrap" :style="'background-image: url(' + bg + ')'">
      <img class="qr" :src="qr" @click="handleClick" />
      <div class="footer">
        <div>
          <span>用微信号</span>
          <span class="wx">{{ id }}</span>
        </div>
        <div>识别二维码 即可绑定成为分享员</div>
        <div class="time">二维码将于 {{ time }} 后失效</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { getSharerInviteInfo } from '@/api/sph'
import { useRoute } from 'vue-router'
import usePage from '@/hooks/usePage'
import wx from 'weixin-js-sdk'

const { isMiniProgram } = usePage()
const { sharer_id } = useRoute().query
const bg = ref()
const qr = ref()
const id = ref()
const time = ref()
const is = ref(false)

const handleClick = () => {
  if (!qr.value || !is.value) return
  wx.previewMedia({ sources: [qr.value] })
}

onMounted(async () => {
  if (!sharer_id) return
  const { invite_qrcode_url, invite_bg_img, weixin_no, invite_expired_time } = await getSharerInviteInfo({
    sharer_id: Number(sharer_id)
  })
  bg.value = invite_bg_img
  qr.value = invite_qrcode_url
  id.value = weixin_no.substr(0, 3) + '***' + weixin_no.substr(weixin_no.length - 3, 3)
  time.value = invite_expired_time
  is.value = await isMiniProgram()
})
</script>

<style lang="less" scoped>
.container {
  background: #ffffff;
  overflow: hidden;

  .wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .qr {
    margin-top: 290px;
    width: 220px;
    height: 220px;
  }

  .footer {
    padding: 0 16px;
    margin-top: 12px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wx {
      color: #5387ff;
    }
    .time {
      margin-top: 20px;
      color: #ff97a3;
      line-height: 16px;
      font-size: 11px;
      font-weight: 400;
    }
  }
}
</style>
